import React, { useState, useContext } from 'react';
import { Tabs } from './TabsSection';
import { Option } from './types';
import { CardTypeTab } from './CardTypeTab';
import { BrandTab } from './BrandTab';
import { SelectionPills } from './SelectionPills';
import { WalletSortAndFilterContext } from './context';
import { SortByDropdownMenu } from 'features/search/components/SortByDropdownMenu';
import { sortOptions } from './util';
import { FlipgiveWalletBanner } from 'features/wallet/components/FlipgiveWalletBanner';

/*
 * Renders the Tabs, Results Text and the different tab contents
 */

export const FilterContent = ({ brands }: { brands: Option[] }) => {
    const [activeTab, setActiveTab] = useState<'cardType' | 'brand'>('cardType');
    return (
        <div className="mt-5">
            <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
            <CardTypeTab isActive={activeTab === 'cardType'} />
            <BrandTab isActive={activeTab === 'brand'} brands={brands} />
            <SelectionPills />
            <FlipgiveWalletBanner />
        </div>
    );
};

const FilterHeader = () => {
    const { result } = useContext(WalletSortAndFilterContext);
    return (
        <div>
            <p className="text-brand-dark text-2xl font-semibold">
                Filter & Sort
                <span className="text-base font-normal"> {result} Results</span>
            </p>
        </div>
    );
};

const SortHeader = () => {
    const { sortedBy, setSortedBy } = useContext(WalletSortAndFilterContext);
    const options = Object.values(sortOptions);

    return (
        <SortByDropdownMenu sortOptions={options} sortedBy={sortedBy} setSortedBy={setSortedBy} />
    );
};

const FilterAndSortHeader = () => {
    return (
        <div className="border-solid border-b px-6 border-grey-3 flex justify-between">
            <FilterHeader />
            <SortHeader />
        </div>
    );
};

export const FilterAndSortSection = ({ brands }: { brands: Option[] }) => {
    return (
        <div>
            <FilterAndSortHeader />
            <FilterContent brands={brands} />
        </div>
    );
};
